import { WSButton, WSFormOld, WSText } from "@wingspanhq/fe-component-library";
import { IMember, INewUser } from "@wingspanhq/users/dist/lib/interfaces";
import React from "react";
import { WSErrorMessage } from "../../../components/WSErrorMessage/WSErrorMessage";
import { FormPartialAddress } from "../FormPartialAddress";
import { FormPartialBankCard } from "../FormPartialBankCard";
import { selectorDefaultValues } from "./selectorDefaultValues";
import { FormData } from "./types";
import { validationSchema } from "./validationSchema";

type Props = {
  user: INewUser;
  member: IMember;
  onSubmit: (data: FormData) => void;
  error?: any;
  isLoading?: boolean;
};

export const Form: React.FC<Props> = ({
  user,
  member,
  onSubmit,
  error,
  isLoading
}) => (
  <WSFormOld<FormData>
    defaultValues={selectorDefaultValues(user, member)}
    validationSchema={validationSchema}
    onSubmit={onSubmit}
  >
    <WSText.Heading5 mb="XL">Card Details</WSText.Heading5>

    <FormPartialBankCard name="card" mb="2XL" />

    <WSText.Heading5 mb="XL">Billing Address</WSText.Heading5>
    <FormPartialAddress name="address" mb="XL" />

    <WSErrorMessage
      my="XL"
      contextKey="BankCard"
      forceShowApiErrors
      error={error}
    />

    <WSButton
      name="submitDebitCard"
      fullWidth
      type="submit"
      loading={isLoading}
    >
      Continue
    </WSButton>
  </WSFormOld>
);
